import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-bild-scaled';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentBildScaledEffects {

    IncidentBildScaled$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_BILD_SCALED),
        mergeMap((x: ac.GetIncidentBildScaledAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentBildScaled(x.incident_id, x.bild_id, x.width, x.height).pipe(
                map((result: any) => {
                    return new ac.GetIncidentBildScaledErfolgreichAction(result, x.incident_id, x.bild_id, x.width, x.height, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentBildScaledFehlerAction(error, x.incident_id, x.bild_id, x.width, x.height, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
